import React from "react";
import { Controller } from "react-hook-form";
import { Checkbox } from "primereact/checkbox";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";

const FormCheckboxGroup = ({
  name,
  control,
  label,
  options,
  onChange,
  defaultValue = [],
  error,
  disabled = false
}) => {
  const StyledCheckbox = styled(Checkbox)(() => ({
    margin: "5px 5px 5px 5px"
  }));

  return (
    <div style={{ minWidth: 120 }}>
      <p className="detail-label">{label}</p>
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        render={({ field }) => (
          <Grid container spacing={2}>
            {options.map((option, index) => (
              <Grid item xs={12} md={3} key={index}>
                <div className="flex align-center">
                  <StyledCheckbox
                    disabled={disabled}
                    inputId={`${name}-${option.value}`}
                    checked={field.value.includes(option.value)}
                    onChange={(e) => {
                      const isChecked = e.checked;
                      let newValue = isChecked
                        ? [...(field.value || []), option.value]
                        : (field.value || []).filter(
                            (val) => val !== option.value
                          );

                      field.onChange(newValue);
                      onChange && onChange(newValue);
                    }}
                  />
                  <label htmlFor={`${name}-${option.value}`}>
                    {option.label}
                  </label>
                </div>
              </Grid>
            ))}
          </Grid>
        )}
      />
      {error && <p className="error-message">{error.message}</p>}
    </div>
  );
};

export default FormCheckboxGroup;
